import { IMDTDashboard } from "models/mdt";
import { IMDTDashboard as NoMDTDashboard } from "models/noMdt";
import { IMDTDashboard as CRCDashboard } from "models/crc";
import { IBreastDashboard } from "models/breast";
import { ActionTypes } from "./actions";
import { ILungDashboard } from "models/lung";
import { IBrainDashboard } from "models/brain";
import { IHeadAndNeckDashboard } from "models/headAndNeck";
import { IYouthCancerDashboard } from "models/youthCancer";
import { IAMLDashboard } from "models/aml";
import { initialState } from "./initialState";

export const pageReducer = (state: { dashboard: (IMDTDashboard | NoMDTDashboard | CRCDashboard | IBreastDashboard | ILungDashboard | IBrainDashboard | IHeadAndNeckDashboard | IYouthCancerDashboard | IAMLDashboard); loading: boolean; computing: boolean }, action: any) => {
	switch (action.type) {
		case ActionTypes.UserLoadedMdtDashboard:
			state.dashboard = action.payload;
			state.loading = false;
			return { ...state };

		case ActionTypes.UserWantsToLoadMdtDashboard:
			state.loading = true;
			return { ...state };

		case ActionTypes.UserWantsToNavigate:
			const nextState = initialState()
			return nextState.page;

		case ActionTypes.UserClickedOnChart:
		case ActionTypes.UserClearedFilters:
			state.dashboard = action.payload;
			state.computing = false;
			return { ...state };

		case ActionTypes.ComputingChartData:
			state.computing = true;
			return { ...state };



		default:
			return state;
	}
}